// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"215":"62d87c85","323":"a534be9f","328":"b717bc42","424":"cea4ea51","453":"ad0c6247","613":"9ba97a27","674":"edab2ca6","731":"a5699e24","747":"5b663c8f","796":"7b5ed563"}[chunkId] + ".chunk.js";
};